import { createSlice } from '@reduxjs/toolkit';

export const SchoolInfoSlice = createSlice({
    name: 'school_info',
    initialState: {
        school_id : '',
        school_name: '',
        school_active_status: '',
        school_official_email_id : '',
        school_principal: ''
    },
    reducers: {
        addSchoolInfo(state, action){
            state.school_id = action.payload.schoolId
            state.school_name = action.payload.schoolName
            state.school_active_status = action.payload.schoolActiveStatus
            state.school_official_email_id = action.payload.schoolOfficialEmail
            state.school_principal = action.payload.schoolPrincipal
        },
        clearSchoolInfo(state) {
            state.school_id = ''
            state.school_name = ''
            state.school_active_status = ''
            state.school_official_email_id = ''
            state.school_principal = ''
        },
    }
})

export const { addSchoolInfo, clearSchoolInfo } = SchoolInfoSlice.actions;
export default SchoolInfoSlice.reducer 